module.exports = __webpack_public_path__ + "static/media/jKCements.d620fa54.svg";